"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = void 0;
var Styling_1 = require("../../Styling");
var getStyles = function (props) {
    return {
        root: props.className,
        screenReaderText: Styling_1.hiddenContentStyle,
    };
};
exports.getStyles = getStyles;
//# sourceMappingURL=Announced.styles.js.map